<div class="upload-container">
  <div class="upload-section">
    <h2>Upload Google Search Console Data</h2>
    <p class="instructions">
      Select a ZIP file exported from Google Search Console containing Query.csv or Page.csv files.
    </p>
    
    <div class="file-input-wrapper">
      <input 
        type="file" 
        accept=".zip" 
        (change)="onZipSelected($event)"
        [disabled]="isProcessing"
        id="zip-file-input"
        class="file-input"
      />
      <label for="zip-file-input" class="file-input-label" [class.disabled]="isProcessing">
        <span class="upload-icon">📎</span>
        <span class="upload-text">
          {{ isProcessing ? 'Processing...' : 'Choose ZIP File' }}
        </span>
      </label>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="isProcessing" class="loading">
      <div class="spinner"></div>
      <p>Processing your file...</p>
    </div>

    <!-- Error message -->
    <div *ngIf="errorMessage" class="message error">
      <span class="message-icon">❌</span>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Success message -->
    <div *ngIf="successMessage" class="message success">
      <span class="message-icon">✅</span>
      <span>{{ successMessage }}</span>
    </div>
  </div>

  <div class="help-section">
    <h3>How to export from Google Search Console:</h3>
    <ol>
      <li>Go to Google Search Console</li>
      <li>Navigate to Performance → Search Results</li>
      <li>Set your desired date range and filters</li>
      <li>Click the "Export" button</li>
      <li>Choose "Export as ZIP" to download your data</li>
    </ol>
  </div>
</div>